import router from '@/common/router';
import { getV11DashboardsStartScreen } from '@/api-client/dashboard/queries/dashboard-v11-controller/dashboard-v11-controller';

export const useLoginRoute = () => {
  const getStartDashboardId = async (): Promise<number> => {
    try {
      const response = await getV11DashboardsStartScreen();
      return response?.data?.data?.[0] ?? -1;
    } catch {
      return -1;
    }
  };

  const goDashboard = async () => {
    const startScreenId = await getStartDashboardId();
    if (startScreenId > 0) {
      await router.push({
        name: 'dashboard_Dashboard View',
        params: {
          id: startScreenId,
        },
      });
    } else {
      await router.push('/home');
    }
  };

  return {
    getStartDashboardId,
    goDashboard,
  };
};
